import { Bot, Trash2 } from 'lucide-react';

import { Button } from 'components/ui/button';
import type { AgentSummary } from 'features/chat/agent-chat-module/types/agent.service.type';

type AgentConfigSubagentCardProps = {
  agent: AgentSummary;
  onRemove: (agentId: string) => void;
  disabled?: boolean;
};

export function AgentConfigSubagentCard({
  agent,
  onRemove,
  disabled = false,
}: AgentConfigSubagentCardProps) {
  return (
    <div
      className={`flex min-w-0 items-center justify-between gap-3 rounded-lg border p-4 ${disabled ? 'opacity-50' : ''}`}
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">
        {agent.logo_url ? (
          <img
            src={agent.logo_url}
            alt=""
            className="h-10 w-10 flex-shrink-0 rounded object-cover"
          />
        ) : (
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded bg-primary/10">
            <Bot className="h-5 w-5" />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <div className="truncate font-medium text-foreground">{agent.name}</div>
          <div className="line-clamp-1 text-sm text-muted-foreground">
            {agent.description || agent.role || 'No description'}
          </div>
        </div>
      </div>

      <Button
        type="button"
        variant="outline"
        onClick={() => onRemove(agent.id)}
        disabled={disabled}
        className="shrink-0 text-muted-foreground hover:text-destructive disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
